import PropTypes from 'prop-types';
import React, {Component} from 'react';
import styled from 'styled-components';

const ErrorContainer = styled.div`
  position: fixed;
  top: 0;
  left: 50%;
  transform: translate(-50%,0);
  width: 700px;
  max-width: 100%;
  background: ${props => props.theme.secondaryColor}
  text-align:center
  z-index: 1000;
  color: ${props => props.theme.primaryColor};
  padding: 10px;
  font-size: 16px;
`;

var timerRunning = false;

class ErrorMessage extends Component {
  static state = {
    timeout: false,
  };

  static propTypes = {
    errors: PropTypes.array,
  };

  componentWillReceiveProps(newProps) {
    if (newProps.errors && newProps.errors.length > 0 && timerRunning === false) {
      this.setState({timeout: false});
      timerRunning = true;
      setTimeout(() => {
        this.setState({timeout: true});
        timerRunning = false;
      }, 5000);
    }
  }

  render() {
    const {errors} = this.props;
    if (!errors || errors.length === 0 || this.state.timeout === true) {
      return null;
    }
    return (
      <ErrorContainer>
        {errors.map((error, i) => {
          let err = error;
          if (error.message) {
            err = error.message.replace('GraphQL error:', '');
          }
          return <div key={'error_' + i}>{err}</div>;
        })}
      </ErrorContainer>
    );
  }
}

export default ErrorMessage;



// WEBPACK FOOTER //
// ./src/components/ErrorMessage.js